import {BdMapsStateSelectHandler} from '../select-handler';

export abstract class BdMapsStateAbstractSelectList<T> {

  public selectionHandler: BdMapsStateSelectHandler<T>;
}
